import Vue from 'vue';
import VueRouter from 'vue-router';
// import Main from '@/components/Main';
import { store } from '@/store';
import { mixin } from '@/utils/mixins';

// guard проверка на повторный переход в тот же роут
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

// import { errorHandler } from '../utils/errorHandler'

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  mixins: [mixin],
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Dashboard',
      meta: { auth: true, layout: 'main', module: 'Dashboard' },
      component: () => import('Parts/HomePage/HomePage')
    },
    {
      path: '/widgetEdit',
      name: 'widgetEdit',
      meta: { auth: true, layout: 'main' },
      component: () => import('Parts/HomePage/WidgetEdit')
    },
    {
      path: '/storybook',
      name: 'StoryBook',
      meta: { auth: true, layout: 'main' },
      component: () => import('@/components/StoryBook')
    },
    {
      path: '/candidates/edit',
      name: 'candidatesEdit',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateEditWrapper')
    },
    {
      path: '/candidates/edit/:id',
      name: 'candidatesEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateEditWrapper')
    },
    {
      path: '/duplicates',
      name: 'HRPAC_CANDIDATES_DUPLICATES',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Dublicates/List/DublicatesWrapper')
    },
    {
      path: '/candidates',
      name: 'HRPAC_CANDIDATES',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateWrapper'),
      children: [
        {
          path: '/candidates/:id',
          name: 'candidateId',
          meta: {
            auth: true,
            layout: 'main',
            parent: '/candidates',
            module: 'HRPAC_CANDIDATES'
          }
        }
      ]
    },
    {
      path: '/candidates/:id/compare',
      name: 'candidateCompare',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/candidates',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/Candidate/List/CandidateCompareWrapper'),
      children: [
        {
          path: '/candidates/:id/compare/:dublicateId',
          name: 'candidateCompareId',
          meta: {
            auth: true,
            layout: 'main',
            parent: '/candidates',
            module: 'HRPAC_CANDIDATES'
          }
        }
      ],
      async beforeEnter(to, from, next) {
        store.commit('candidate/setMetadata', {});
        next();
      }
    },
    {
      path: '/candidates/AttachmentPage/:id',
      name: 'candidatesAttachmentPageId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/candidates/AttachmentPage',
        module: 'HRPAC_CANDIDATES'
      },
      component: () => import('Parts/AttachmentPage/AttachmentPage')
    },
    {
      path: '/vacancies/:id/AttachmentPage',
      name: 'candidatesAttachmentPage',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/vacancies/:id/AttachmentPage',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/AttachmentPage/MassAttachmentPage')
    },
    {
      path: '/notifications',
      name: 'Notifications',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/notifications',
        module: 'HRPAC_NOTIFICATIONS'
      },
      component: () => import('Parts/Notifications/View/Notifications')
    },
    {
      path: '/notificationsSetting',
      name: 'HRPAC_NOTIFICATIONS_SETTINGS',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/notifications',
        module: 'HRPAC_NOTIFICATIONS_SETTINGS'
      },
      component: () => import('Parts/Notifications/View/NotificationsSettings')
    },
    {
      path: '/vacancies/edit',
      name: 'vacanciesEdit',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/vacancies/edit/:id',
      name: 'vacanciesEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/vacancies/:id/duplicate',
      name: 'vacanciesDuplicate',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },

    {
      path: '/vacancies/:id/createTemplate',
      name: 'vacanciesTemplateId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY_TEMPLATE'
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },

    {
      path: '/vacancies',
      name: 'HRPAC_VACANCY',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/vacancies',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/Vacancy/List/VacancyWrapper'),
      children: [
        {
          path: '/vacancies/:id',
          name: 'vacancyId',
          meta: {
            auth: true,
            layout: 'main',
            parent: '/vacancies',
            module: 'HRPAC_VACANCY'
          },
          component: () => import('Parts/Vacancy/View/VacancyCardNew'),
          async beforeEnter(to, from, next) {
            await store.dispatch('vacancy/getMetadata', to.params.id);

            next();
          }
        }
      ]
    },
    {
      path: '/vacancies/AttachmentPage/:id',
      name: 'vacanciesAttachmentPageId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/vacancies/AttachmentPage',
        module: 'HRPAC_VACANCY'
      },
      component: () => import('Parts/AttachmentPage/AttachmentPage')
    },
    {
      path: '/templates/edit',
      name: 'templateEdit',
      meta: {
        auth: true,
        layout: 'main',
        module: 'HRPAC_VACANCY_TEMPLATE',
        customUrl:
          '?module=HRPAC_VACANCY_TEMPLATE&action=getTemplateView&record='
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/templates/:id/edit',
      name: 'templateEditId',
      meta: {
        auth: true,
        layout: 'main',
        module: 'HRPAC_VACANCY_TEMPLATE',
        customUrl:
          '?module=HRPAC_VACANCY_TEMPLATE&action=getTemplateView&record='
      },
      component: () => import('Parts/Vacancy/Edit/VacancyEditWrapper')
    },
    {
      path: '/login',
      name: 'LoginPage',
      meta: { auth: false, layout: 'empty' },
      component: () => import('@/components/parts/Auth/LoginPage')
    },
    {
      path: '/auth',
      name: 'AuthSSO',
      meta: { auth: false, layout: 'empty' },
      component: () => import('@/components/parts/Auth/AuthSSO')
    },
    {
      path: '/greeting',
      name: 'Greeting',
      meta: {
        auth: true,
        layout: 'main'
      },
      component: () => import('Parts/Greeting/GreetingPage')
    },
    {
      path: '/calls',
      name: 'CallsList',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/calls',
        module: 'OMS_CALLS'
      },
      component: () => import('Parts/Calls/List/CallsWrapper')
    },
    {
      path: '/restore/:login/:id',
      name: 'RestorePasswordPage',
      meta: { auth: false, layout: 'empty' },
      component: () => import('Parts/Auth/RestorePasswordPage')
    },
    {
      path: '/oldpage/:url',
      props: true,
      name: '*',
      meta: {
        auth: true,
        layout: 'main',
        reload: true
      },
      component: () => import('Parts/OldPage/OldPage')
    },
    {
      path: '/users',
      name: 'Users',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users',
        module: 'Users'
      },
      component: () => import('Parts/Users/List/UsersWrapper')
    },
    {
      path: '/users/:id',
      name: 'UsersId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users',
        module: 'Users'
      },
      component: () => import('Parts/Users/View/UsersCard')
    },
    {
      path: '/users/:id/edit',
      name: 'usersEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id?/edit/general',
      name: 'usersFormEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/calendar',
      name: 'usersEditCalendar',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/mail',
      name: 'usersMailEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/messengers',
      name: 'usersMessangersEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/response',
      name: 'usersResponseEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/users/:id/edit/additionally',
      name: 'usersAdditionallyEditId',
      meta: {
        auth: true,
        layout: 'main',
        parent: '/users/:id/edit',
        module: 'Users'
      },
      component: () => import('Parts/Users/Edit/UsersEditWrapper')
    },
    {
      path: '/global_search',
      props: true,
      name: 'searchPage',
      meta: {
        auth: true,
        layout: 'main',
        reload: true
      },
      component: () => import('Parts/SearchPage_3.0/SearchPage')
    },
    {
      path: '/about',
      props: true,
      name: 'About',
      meta: {
        auth: true,
        layout: 'main'
      },
      component: () => import('Parts/About/About')
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  const isAuth = JSON.parse(localStorage.getItem('auth'));
  const requireAuth = to.matched.some(record => record.meta.auth);

  if (requireAuth && !isAuth) {
    try {
      const response = await mixin.methods.sendFormRequestFromIntent({
        request: {
          url: '?entryPoint=check_session_auth'
        }
      });

      if (response.data?.status && response.data?.status == 'authenticated') {
        store.commit('auth/setAuth');
      } else {
        router.push(`/login?return={${window.location.pathname}}`);
      }
    } catch (error) {
      router.push(`/login?return={${window.location.pathname}}`);
    }
  } else if (!requireAuth && isAuth) {
    next('/');
  } else {
    next();
  }
});

export default router;
